import { EventEmitter } from "events";

export default {
  install(Vue) {
    Vue.prototype.$emitter = new EventEmitter();
  }
};
